import React from 'react';

import { Button } from 'scouting-ui/lib';
import { useSlate } from 'slate-react';

import { onPointerDown, toggleIndent } from './EditorTextArea.utils';
import { getIcon } from './Icon';

type IndentButtonProps = {
  direction: 'indent' | 'outdent';
};

const IndentButton = ({ direction }: IndentButtonProps) => {
  const editor = useSlate();

  return (
    <Button
      data-test-id={`indent-button-${direction}`}
      ghost
      icon={getIcon(direction)}
      onClick={() => toggleIndent(editor, direction)}
      onPointerDown={onPointerDown}
      size="small"
    />
  );
};

export default IndentButton;
